export default import.meta.ROLLDOWN_FILE_URL_KiqomPBf71NN3phYPN5sRQ